import React from 'react'
import './CareersVideoSection.component.scss'

const CareersVideoSection = () => {
  return (
    <section className='careers-video-section'>
      <div className='careers-video-section__grid'>
        <div className='careers-video-section__content'>
          <h2 className='careers-video-section__heading'>
            <span className='careers-video-section__heading-text'>
              Time to Take Your Insurance Career to the Next Level!
            </span>
          </h2>
          <div className='careers-video-section__video-wrapper'>
            <iframe
              title='vimeo-player'
              src='https://player.vimeo.com/video/1132626195?h=4dbe73544b'
              width='640'
              height='360'
              frameBorder='0'
              referrerPolicy='strict-origin-when-cross-origin'
              allow='autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share'
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default CareersVideoSection
